module.exports = __webpack_public_path__ + "static/img/9.db94789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/9.png
// module id = GdQV
// module chunks = 0